import { Injectable } from '@angular/core';
import { Customization } from '../models/customization';
import { AdaCustomizationsService } from './ada-customizations.service';
import { MarsCustomizationsService } from './mars-customizations.service';
import { Game2100CustomizationsService } from './game2100-customizations.service';
import { Game } from 'core/models/game';
import { BehaviorSubject } from 'rxjs';
import { GameCustomizationsHandler } from './game-customizations-handler.interface';

@Injectable()
export class CustomizationsService implements GameCustomizationsHandler {
  public list: Customization[];
  game: Game;
  handlers: any;
  customizationsObservable = new BehaviorSubject<Customization[]>(null);

  constructor(
    protected adaCustomizations: AdaCustomizationsService,
    protected marsCustomizations: MarsCustomizationsService,
    protected game2100Customizations: Game2100CustomizationsService
  ) {
    this.handlers = {
      ada: this.adaCustomizations,
      mars: this.marsCustomizations,
      '2100': this.game2100Customizations
    };
  }

  loadCustomizationsCache(game: Game): Promise<Customization[]> {
    this.game = game;
    if (this.game && this.game.requireCustomization !== 'no' && this.handlers[this.game.canonicName]) {
      return this.handlers[this.game.canonicName].loadCustomizationsCache(game);
    } else {
      return Promise.resolve(null);
    }
  }

  getOptions(clientId: string): any[] {
    if (this.game && this.game.requireCustomization !== 'no' && this.handlers[this.game.canonicName]) {
      return this.handlers[this.game.canonicName].getOptions(clientId);
    } else {
      return [];
    }
  }

  getCachedClientDefaultCustomization(clientId: string): Customization {
    if (this.game && this.game.requireCustomization !== 'no' && this.handlers[this.game.canonicName]) {
      return this.handlers[this.game.canonicName].getCachedClientDefaultCustomization(clientId);
    } else {
      return null;
    }
  }

  getCachedCustomization(id: string): Customization {
    if (this.game && this.game.requireCustomization !== 'no' && this.handlers[this.game.canonicName]) {
      return this.handlers[this.game.canonicName].getCachedCustomization(id);
    } else {
      return null;
    }
  }

  getCustomization(id: string) {
    if (this.game && this.game.requireCustomization !== 'no' && this.handlers[this.game.canonicName]) {
      return this.handlers[this.game.canonicName].getCustomization(id);
    } else {
      return Promise.resolve(null);
    }
  }
}
